import {IUserHr} from '../interfaces/IUserHr'

export const GET_HR_USERS_REQUEST = 'GET_HR_USERS'
export const GET_HR_USERS_SUCCESS = 'GET_HR_USERS_SUCCESS'
export const GET_HR_USERS_FAILURE = 'GET_HR_USERS_FAILURE'


interface GetHrUsersRequest {
    type: typeof GET_HR_USERS_REQUEST
}

interface GetHrUsersRequestSuccess {
    type:  typeof GET_HR_USERS_SUCCESS
    payload: {
        users: IUserHr[]
    }
}

interface GetHrUsersRequestFailure {
    type: typeof GET_HR_USERS_FAILURE
}


export type ActionTypes =
    | GetHrUsersRequest
    | GetHrUsersRequestSuccess
    | GetHrUsersRequestFailure